import { gql } from '@apollo/client';
export const STUDENT_ASSESSMENT_TOOL_GRADE_DTO_FIELDS = gql`
  fragment StudentAssessmentToolGrade on StudentAssessmentToolGradeDto {
    id
    businessUnitId
    studentId
    assessmentToolId
    examCallId
    qualification
  }
`;